import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-16 w-16 items-center justify-center rounded-full bg-pine ${className}`} aria-hidden="true" data-id="element-128" data-mp="1zbqyo7zazzuw">
      <Icon className="h-7 w-7 text-paper-soft" strokeWidth={1.75} data-id="element-129" data-mp="24c4w6w3a3reo" />
    </span>;
}